import React from 'react';
import styles from './RichText.css';
import Framer from '../Framer/Framer'
import {ComponentName, FrameStates} from '../../constants/consts-types'
import {TypeComponentRichText} from '../../constants/consts-prop-types'
import Observer from "react-intersection-observer";

const RichText = props => {
  const {header, content, show_border} = props.data

  return (
    <section className={styles.RichText}>
      <div className="container-fluid">
        <article>
          <div className="row">
            <div className="col-xs-12 col-md-2"></div>
            <div className="col-xs-12 col-md-3 md-text-right">
              {header && (
                <div className={styles.subHeader}>
                  <h2 dangerouslySetInnerHTML={{ __html: header }} />
                </div>
              )}
            </div>
            <div className="col-xs-12 col-md-6 col-md-offset-1">
              <div
                className={
                  show_border ? styles.contentWithFrame : styles.content
                }
              >
                {show_border && (
                  <Observer>
                    {({ inView, ref }) => (
                      <div ref={ref} className={styles.framerWrapper}>
                        <Framer
                          state={
                            inView ? FrameStates.FACT : FrameStates.INIT_FACT
                          }
                        />
                      </div>
                    )}
                  </Observer>
                )}
                {content && (
                  <div dangerouslySetInnerHTML={{ __html: content }} />
                )}
                {props.children}
              </div>
            </div>
          </div>
        </article>
      </div>
    </section>
  );
}

RichText.propTypes = {
  data: TypeComponentRichText
}

RichText.defaultProps = {
  data: {
    component_id: ComponentName.rich_text,
    header: '',
    subheader: '',
    content: '',
    show_border: false,
  }
}

export default RichText;



// WEBPACK FOOTER //
// ./src/components/RichText/RichText.js